import { createFileRoute, Outlet } from "@tanstack/react-router"
import { AccessDenied } from "@/components/shared/errors/access-denied"
import { useHasRole } from "@/hooks/auth/use-has-role"
import { ROLE } from "@/lib/roles"

export const Route = createFileRoute("/_authenticated/_admin")({
	component: AdminLayout,
})

function AdminLayout() {
	const hasAdminRole = useHasRole(ROLE.ADMIN)
	if (!hasAdminRole) return <AccessDenied />
	return <Outlet />
}
